import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { MODE_LABELS, type Mode } from '@tarot/shared';
import { ModeIcon } from '../../components/ModeIcon';

const CARDS: { to: string; mode: Mode; desc: string }[] = [
  { to: '/solo', mode: 'solo', desc: '지금 바로 가볍게 한 장' },
  { to: '/room?mode=couple', mode: 'couple', desc: '둘이서 같은 카드를 함께 열어요' },
  { to: '/room?mode=friends', mode: 'friends', desc: '2~4명이 함께 보는 타로' },
];

export function HomePage() {
  return (
    <div className="flex flex-1 flex-col justify-center gap-8">
      <div className="text-center">
        <h1 className="text-3xl font-bold leading-tight">
          오늘, <span className="text-gold">무엇이</span> 궁금하세요?
        </h1>
        <p className="mt-2 text-moon-dim">혼자서도, 함께서도. 카드가 답해 드려요.</p>
      </div>

      <ul className="flex flex-col gap-3">
        {CARDS.map((c, i) => (
          <motion.li
            key={c.mode}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.08 * i, duration: 0.4, ease: 'easeOut' }}
          >
            <Link
              to={c.to}
              className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/5 p-4 backdrop-blur transition hover:border-gold/60 hover:bg-white/10 active:scale-[0.99]"
            >
              <ModeIcon mode={c.mode} className="h-14 w-14 shrink-0 text-gold" />
              <span className="flex flex-col">
                <span className="font-semibold">{MODE_LABELS[c.mode].ko} 타로</span>
                <span className="text-sm text-moon-dim">{c.desc}</span>
              </span>
            </Link>
          </motion.li>
        ))}
      </ul>
    </div>
  );
}
